// Ported from hotwire-flow (MIT, @hotwirebits/flow) into conek-ui. The engine
// logic is upstream's; identifiers/events/classes follow the conek contract in
// docs/superpowers/specs/2026-09-09-flow-graph-components-design.md §2.
import { Controller } from "@hotwired/stimulus"

// Drop zone on the canvas — receives DnD from sidebar to create nodes.
export default class extends Controller {
  static outlets = ["ui--flow"]

  dragOver(event) {
    if (event.dataTransfer.types.includes("application/hotwire-flow-node")) {
      event.preventDefault()
      event.dataTransfer.dropEffect = "copy"
    }
  }

  dragEnter(event) {
    if (event.dataTransfer.types.includes("application/hotwire-flow-node")) event.preventDefault()
  }

  dragLeave() {}

  drop(event) {
    const data = event.dataTransfer.getData("application/hotwire-flow-node")
    if (!data) return
    event.preventDefault()

    let nodeData
    try { nodeData = JSON.parse(data) } catch (e) { return }
    const flow = this.uiFlowOutlet
    if (!flow) return

    const pos = flow.screenToFlow(event.clientX, event.clientY)
    this.element.dispatchEvent(new CustomEvent("ui--flow:drop", { detail: { type: nodeData.type, label: nodeData.label, x: pos.x, y: pos.y }, bubbles: true }))
  }
}
